module.exports = __webpack_public_path__ + "img/coating.26a9966b.svg";